var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FloatingContainer,{attrs:{"mode":"pc"}},[_c(_setup.LanguageButton),_c(_setup.EbmedicalHomeBtn),_c(_setup.SurveyButton),_c(_setup.FeedbackButton),_c(_setup.SubscriptionButton),_c(_setup.TopButton)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }